"use client";
import React, { useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { message } from "antd";
import Link from "next/link";
import {
  Button,
  CircularProgress,
  Typography,
  Stack,
  Box,
  TextField,
} from "@mui/material";
import "./index.css";
import AccountApi from "@/Apis/AccountApi";
const ForgotPassword = () => {
  const inputPropsObj = {
    sx: {
      borderRadius: "10px",
      fontSize: "13px",
      color: "rgba(71, 71, 71, 0.85)",
      "&:hover, &:focus": {
        outline: "none",
        border: "red",
      },
    },
  };
  const buttonStyleObj = {
    borderRadius: "10px",
    fontSize: "13px",
    color: "rgba(71, 71, 71, 0.85)",
    width: "60%",
    height: "40px",
    margin: "20px auto",
    color: "white",
  };

  const [email, setEmail] = useState("");
  const [emailError, setemailError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const [emailSentCheck, setEmailSentCheck] = useState(false);

  const submitEmail = async (e) => {
    setLoadingButton(true);
    e.preventDefault();
    if (email !== "" && email) {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const isValidEmail = emailRegex.test(email);
      if (isValidEmail) {
        const obj = { email: email };
        const data = await AccountApi.forgotPassword(obj)
          .then((res) => {
            if (res.status === 200) {
              message.success(res.data.response);
              setEmailSentCheck(true);
              setLoadingButton(false);
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.status === 400) {
              message.error(err.response.data.detail);
              console.log(err.response.data.detail);
              setLoadingButton(false);
            } else {
              message.error("Something went wrong");
              console.log("Something went wrong");
              setLoadingButton(false);
            }
          });
      } else {
        setEmailErrorMessage("Enter valid Email Address");
        setemailError(true);
        setLoadingButton(false);
      }
    } else {
      setEmailErrorMessage("Email is required");
      setemailError(true);
      setLoadingButton(false);
    }
  };

  const handleEmailChange = (value) => {
    setEmail(value);
  };

  return (
    <>
      <div className="forgotPasswordMainContainer">
        {emailSentCheck ? (
          <Box className="forgot-password-email-sent-container">
            <Typography className="forgotPasswordHeading">
              Check Email
            </Typography>
            <Typography className="forgot-password-second-heading-email-sent">
              Please check your email inbox and click on the provided link to
              reset your password. If you don&lsquo;t receive email{" "}
              <span
                onClick={() => {
                  setEmailSentCheck(false);
                }}
                className="forgot-password-link"
              >
                {" "}
                click here to resend{" "}
              </span>
            </Typography>
            <Box display={"flex"} paddingTop={"25px"}>
              <Link href="/login">
                <Box display={"flex"}>
                  <Box paddingTop={"2px"}>
                    <ArrowBackIosNewIcon fontSize="4px" />
                  </Box>
                  <Box alignSelf={"center"}>
                    <Typography className="forgot-password-second-heading-email-sent-link">
                      Back to Login
                    </Typography>
                  </Box>
                </Box>
              </Link>
            </Box>
          </Box>
        ) : (
          <form
            onSubmit={(e) => {
              submitEmail(e);
            }}
          >
            <Stack container gap={"0px"} padding={" 5px 20px"}>
              <Typography className="forgotPasswordHeading">
                Recover Your Password
              </Typography>
              <Typography
                className="forgotPasswordSecondHeading"
                marginBottom={"10px"}
              >
                We will send you an email to reset your password.
              </Typography>

              <TextField
                placeholder="Email Address"
                onChange={(e) => {
                  handleEmailChange(e.target.value);
                }}
                className="forgotPasswordInput"
                InputProps={inputPropsObj}
              />
              {emailError && (
                <Typography
                  color={"red"}
                  fontSize={"11px"}
                  padding={"10px 0px 0px 15px"}
                >
                  {emailErrorMessage}
                </Typography>
              )}
              <Button
                variant="contained"
                padding="17px 26px"
                type="submit"
                style={buttonStyleObj}
                className="forgotPasswordButton"
              >
                {loadingButton ? (
                  <Box sx={{ display: "flex" }}>
                    <CircularProgress color="inherit" />
                  </Box>
                ) : (
                  <Typography className="forgotPasswordButtonText">
                    Send
                  </Typography>
                )}
              </Button>
            </Stack>
          </form>
        )}
      </div>
    </>
  );
};

export default ForgotPassword;
